import { GrowthBookProvider } from '@growthbook/growthbook-react';
import { useEffect } from 'react';
import { growthbook } from './growthbook';

export function GrowthBookProviderWrapper({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    growthbook.init({ streaming: true });
  }, []);

  return <GrowthBookProvider growthbook={growthbook}>{children}</GrowthBookProvider>;
}
